export interface VueAppConfig {
	API_URL: string;
	LEAD_URL: string;
	TRADE_PENDING_API: string;
	GATEWAY_URL: string;
	TRADE_PENDING_URL: string;
	AMPLITUDE_KEY: string;
	SENTRY_DSN: string;
	RECAPTCHA_SITE_KEY: string;
	MAINTENANCE_MODE: boolean|string;
}
declare const VUE_APP_CONFIG: VueAppConfig;

export const APP_CONFIG = { ...VUE_APP_CONFIG } as const;
